import {TNS3ND_CONTEXT,getTnsSdkScriptSrc,parseURL, isEnableCdn} from "../utils/loadResources";
import {debugLog} from "../utils/loadResources";
// git版本号
const COMMIT_LAST_DATE = process.env.COMMIT_LAST_DATE;


// 自动获取tnsSdk.js的完整url
export function getCurrUrl() {
    var scriptUrl = "";
    //通过当前脚本获取url
    if (document && document.currentScript){
        scriptUrl = document.currentScript.src;
    }else {//对于一些不支持document.currentScript浏览器（IE）等进行兼容
        scriptUrl = getTnsSdkScriptSrc();
    }
    // console.log("AAA---currTnsSdk :"+scriptUrl);
    if (!scriptUrl) {
        throw new Error("[TNE]Automatic host is not supported in this browser");
    }
    return scriptUrl;
}
// 从完整url中获取域名
function getCurrHost(url){
    let scriptUrl = url.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/")
        .replace("/iuap-tns/".concat("ucf-wh/share/runtime"),"/iuap-3rd-party".concat("/ucf-wh"));
    return scriptUrl;
}

function loadTne3rd() {
    var currUrl = getCurrUrl();
    // console.log("AAA---currUrl tns3nd:"+currUrl);
    var urlInfo = parseURL(currUrl);
    var tns3nd = urlInfo.params.tns3nd; //默认加载tns3nd.js资源，如需禁用设置false
    if(tns3nd==false || tns3nd=='false'){
        debugLog("[TNE]已禁用tne3rd-runtime.js");
        return;
    }else{
        debugLog("[TNE]开始动态加载tne3rd-runtime.js");
    }
    var same = urlInfo.params.same; //是否保持同源
    var mode = urlInfo.params.mode; //加载模式，async-异步加载 write-同步写入 after-当前脚本节点后插入
    var callback = urlInfo.params.callback; //加载完成后的回调函数名
    var tns3ndContext = '/iuap-3rd-party/ucf-wh/';
    var tns3ndSubDir= 'lib3rd';
    var tns3ndFileName = 'tne3rd-runtime.js';
    var tns3ndHost = getCurrHost(currUrl);
    try {
        // 专属化支持cdn域名
        if(!isEnableCdn() && window.cdn_privateHost){
            tns3ndContext = window.cdn_privateHost + tns3ndContext;
        }
    } catch (error) {
        
    }
    var scriptSrc = tns3ndContext+tns3ndSubDir+"/"+tns3ndFileName;
    if (window.TNS_PUBLIC_PATH) {//通过全局变量获取路径
        if(window.TNS_PUBLIC_PATH.indexOf(tns3ndSubDir)==-1){//子目录不存在则自动补充
            window.TNS_PUBLIC_PATH = window.TNS_PUBLIC_PATH+tns3ndSubDir+"/";
        }
        scriptSrc = window.TNS_PUBLIC_PATH+tns3ndFileName;
    }else{
        if(same){//按同源域名策略加载
            // 当前tnsSdk.js走cdn域名，则不需要替换三方包路径
            if(!isEnableCdn()){
                scriptSrc = tns3ndHost+tns3ndSubDir+"/"+tns3ndFileName;
                window.TNS_PUBLIC_PATH = tns3ndHost+tns3ndSubDir+"/";
            }
        }else{
            if(!isEnableCdn() && window.cdn_privateHost){
                window.TNS_PUBLIC_PATH = tns3ndContext + tns3ndSubDir + "/";
            }
        }
    }
    if(!document){
        console.error('[TNE]动态加载tns3nd.js异常，document元素不存在');
        return;
    }
    var script = document.createElement('script');
    script.type = 'text/javascript';
    // script.async = true;
    script.onerror = function () {
        console.error('[TNE]动态加载tne3rd-runtime.js异常');
    };
    script.onload = script.onreadystatechange = function () {
        if(!script.readyState||script.readyState==='loaded'||script.readyState==='complete'){
            debugLog('[TNE]动态加载tne3rd-runtime.js完成');
            callback && new Function("(" + callback + ")()")()
            // callback && eval(callback+'()')
        }
        script.onload = script.onreadystatechange=null
    };
    script.src = scriptSrc;
    debugLog("[TNE]动态加载tne3rd-runtime.js中");
    if (mode == "append") {
        document.head
            ? document.head.appendChild(script)
            : console.error("[TNE]动态加载tne3rd-runtime.js异常，document.head 不存在");
    } else if (mode == "after") {
        document.currentScript && document.currentScript.after
            ? document.currentScript.after(script)
            : console.error("[TNE]动态加载tns3nd.js异常，document.currentScript.after 不存在");
    } else {
        //html文件中的script标签src属性所引用的js文件的代码内再使用document.write()方式引入的js文件是同步执行的
        var loadedFuncStr =
            "javascript:console.log('[TNE]动态加载tne3rd-runtime.js完成');" +
            (callback ? callback + "()" : "");
        document.write
            ? document.write(
                  '<script type="text/javascript" src="' +
                      scriptSrc +
                      '" onload="' +
                      loadedFuncStr +
                      '"></script>'
              )
            : console.error("[TNE]动态加载tne3rd-runtime.js异常，document.write 不存在");
    }
}
// 执行tns3nd的加载
if(!tnsSdk){ //tnsSdk.js首次加载，触发tns3nd.js加载
    loadTne3rd();
}else{
    //tnsSdk.js被多次引用加载时，不在触发tns3nd.js加载。
}

/**
 * 动态加载三方包，等价代替 import() 语句
 * @param packageName 三方包名
 * @return {Promise<*>}
 * @example
 *  const axios = await tnsSdk.asyncImport3nd('axios');
 *  console.log(axios)
 */
export async function asyncImport3rd(packageName){
    if(!window.tns3nd){
        console.error('[TNE]tns3nd不存在');
        return;
    }
    if (!packageName){
        console.error('[TNE]packageName参数必须存在');
        return;
    }
    const factory = await window.tns3nd.get(`./${packageName}`);
    if(!factory){
        console.error('[TNE]不存在三方包:'+packageName);
        return;
    }
    const lib = factory();
    return lib.default ? lib.default : lib;
}